// extracted by mini-css-extract-plugin
module.exports = {"backToExplorer":"BackToExplorer_backToExplorer__qJvYz","mobile":"BackToExplorer_mobile__0oW1U"};